module.exports = __webpack_public_path__ + "img/Number=27.d51b7d6f.png";